import { render, staticRenderFns } from "./EnterNewEvent.vue?vue&type=template&id=6f6b102e"
import script from "./EnterNewEvent.vue?vue&type=script&lang=js"
export * from "./EnterNewEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports